import { css } from 'styled-components';
import { Heading, SharingButtons } from '../../../../components/ShareWidget/styles';
import spacing from '../../../../helpers/spacing';
import { fonts } from '../../../RSA/fonts';
import { colors, themeSpecificColors } from '../../colors';

export default css`
  ${SharingButtons} {
    button {
      border-radius: 48px;

      margin-right: ${spacing(2)};
      margin-bottom: ${spacing(2)};

      ::before {
        display: none;
      }

      &:hover,
      &.focus {
        img {
          transform: unset;
        }
      }

      &:focus img {
        transform: unset;
      }

      &:hover {
        box-shadow: 0px 0px 0 4px ${themeSpecificColors.core01_60};
      }

      &:focus {
        box-shadow: none;
      }

      &:focus-visible {
        box-shadow: 0px 0px 0 2px ${colors.core01},
          0px 0px 0 6px ${themeSpecificColors.core01_60};
      }

      &:active {
        box-shadow: 0px 0px 0 2px ${colors.core01},
          0px 0px 0 12px ${themeSpecificColors.core01_60};
      }
    }
  }

  ${Heading} {
    ${fonts.headingXSmall};
    font-weight: 700;
  }
`;
